import React, { FC } from "react";
import { IconProps } from "iconsax-react";
import { useThemeColors } from "../../Store/modules/theme";
import { Color } from "../../StyleSheet";

export type Props = IconProps & {
  Component: FC<IconProps>;
  color?: Color;
  _color?: string;
};

export const Icon: React.FC<Props> = (props) => {
  const { Component, color, _color } = props;
  const [theme] = useThemeColors();
  return <Component {...props} color={color ? theme[color] : _color} />;
};
